import { render } from "./PositionTraining.vue?vue&type=template&id=abdf2094&ts=true"
import script from "./PositionTraining.vue?vue&type=script&lang=ts"
export * from "./PositionTraining.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__